import { IVector2 } from "../types/game-config-type";
import { table } from "../game/table";
export class MenuLabel {
  constructor(
    private text: string,
    private position: IVector2,
    private font: string,
    private color: string,
    private alignment: string
  ) {}

  public draw(): void {
    table.drawText(this.text, this.font, this.color, this.position, this.alignment);
  }
}
